import React from 'react';
import { capitalize } from 'lodash';
import { Col, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { GROUP_ROLES, GROUP_ROLES_DESC } from '../../../../lib/schema.js';
import CheckboxAdapter from '../../../CheckboxAdapter.jsx';
import GroupsBulkSelect from '../../../GroupsBulkSelect.jsx';
import GroupRow from '../../../group-form-field/GroupRow.jsx';

const roleOptions = GROUP_ROLES.map((role, index) => ({
  label: capitalize(role),
  value: role,
  desc: GROUP_ROLES_DESC[index],
}));

const GroupRole = ({ selectedGroups, onGroupSelect, errors, submitFailed }) => {
  return (
    <Row>
      <Col xs={12} className="m-b-24">
        <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
          <h3>Select Role</h3>
        </div>

        <p className="communication-help text-muted">
          {getOrgTermsContent('projectRoleSubtitle')}
        </p>
      </Col>

      <Col xs={10} className="m-b-60">
        <GroupsBulkSelect
          selected={selectedGroups}
          handleSelect={onGroupSelect}
          onShowGroupModal={() => {}}
          isItemActive={(id) => selectedGroups.some((g) => g.id === id)}
        />
        {submitFailed && (
          <FormGroup validationState="error">
            <HelpBlock>{errors.groups}</HelpBlock>
          </FormGroup>
        )}

        {selectedGroups.map((group, index) => (
          <React.Fragment key={group.id}>
            <div className="m-b-16">
              <GroupRow
                index={index}
                group={group}
                handleRemove={onGroupSelect}
              />
            </div>
            {roleOptions.map((role) => {
              return (
                <div className="m-b-24 m-l-16" key={`projectRole${role.value}`}>
                  <Field
                    key={role.value}
                    className="m-0"
                    name={`groups[${group.id}]`}
                    label={role.label}
                    value={role.value}
                    type="checkbox"
                    component={CheckboxAdapter}
                  />
                  <p className="text-muted m-l-32 m-b-0">{role.desc}</p>
                </div>
              );
            })}
            {submitFailed && (
              <FormGroup validationState="error">
                <HelpBlock>{errors[`groups[${group.id}]`]}</HelpBlock>
              </FormGroup>
            )}
          </React.Fragment>
        ))}
      </Col>
    </Row>
  );
};

export default GroupRole;
